<script setup lang="ts">
type Props = {
  msg: string;
};
const props = defineProps<Props>();
const emit = defineEmits(["undo"]);

const undo = () => {
  emit("undo");
};
</script>

<template>
  <div class="flex justify-between items-center gap-x-3">
    <p>{{ props.msg }}</p>
    <button
      @click="undo"
      class="p-2 rounded-sm bg-blue-200 text-black hover:bg-blue-100"
    >
      <span class="text-lg font-mono">↺</span> Undo
    </button>
  </div>
</template>
